import { latLng } from 'leaflet';

export default {
  data() {
    return {
      mapTileUrl: null,
      zoom: null,
      fenceZoom: null,
      fenceCenter: null,
      center: null,
      attribution: '&copy; Asemantech',
    };
  },
  methods: {
    setMapBaseSystemSetting: function (data) {
      if (!data) data = this.$store.state.SystemSettingModule.systemSetting;
      this.mapTileUrl = data?.mapTile;
      if (!data?.mapCenterLatitude) {
        this?.zoomUpdate?.(6);
        this.zoom = 6;
      } else {
        this?.zoomUpdate?.(data?.mapDefaultZoomLevel ?? 11);
        this.zoom = data?.mapDefaultZoomLevel ?? 11;
      }
      const center = latLng(data?.mapCenterLatitude ?? 29.345, data?.mapCenterLongitude ?? 57);

      this.center = center;
      this?.centerUpdate?.(center);
    },

    setFanceMapBaseSystemSetting: function (data) {
      if (!data) data = this.$store.state.SystemSettingModule.systemSetting;
      this.mapTileUrl = data?.mapTile;
      this.fenceCenter = latLng(
        data?.mapCenterLatitude ?? 30.2839,
        data?.mapCenterLongitude ?? 57.0834,
      );
      const center = latLng(
        data?.mapCenterLatitude ?? 30.2839,
        data?.mapCenterLongitude ?? 57.0834,
      );
      this.fenceCenter = latLng(
        data?.mapCenterLatitude ?? 30.2839,
        data?.mapCenterLongitude ?? 57.0834,
      );
      this.centerUpdate?.(center);
      this.fenceZoom = data?.mapDefaultZoomLevel ?? 6;
      this?.fanceZoomUpdate?.(data?.mapDefaultZoomLevel ?? 6);
    },
    fanceZoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    setMapSettings: function (data) {
      this.setMapBaseSystemSetting(data);
      this.setFanceMapBaseSystemSetting(data);
    },
  },
  computed: {
    isMapReadyToShow: function () {
      return !!this.mapTileUrl && !!this.zoom && !!this.center;
    },
    isFenceMapReadyToShow: function () {
      return !!this.mapTileUrl && !!this.fenceZoom && !!this.fenceCenter;
    },
  },
  watch: {
    '$store.state.SystemSettingModule.systemSetting': {
      handler: function (currentVal) {
        this.setMapSettings(currentVal);
      },
    },
  },
};
